// ============================================================
// phases.js — Unified phase transition checker
// ============================================================
// Replaces the duplicated phase-check logic that appears in:
//   1. The smiley click handler
//   2. Auto-clicker tick intervals
//   3. loadGame() restoration
//
// Every place that changes the score simply calls
// checkPhaseTransitions() afterwards.
// ============================================================
import { state } from './state.js';

// Forward-declared activate/deactivate functions.
// Set once at bootstrap via providePhasesDeps().
let activateBombMode;
let activateFrozenMode;
let activatePhase3;
let activatePhase4;
let activatePhase5;
let activateEyeBoss;
let updateEscapeProgress;
let triggerWin;

export function providePhasesDeps(deps) {
  activateBombMode     = deps.activateBombMode;
  activateFrozenMode   = deps.activateFrozenMode;
  activatePhase3       = deps.activatePhase3;
  activatePhase4       = deps.activatePhase4;
  activatePhase5       = deps.activatePhase5;
  activateEyeBoss      = deps.activateEyeBoss;
  updateEscapeProgress = deps.updateEscapeProgress;
  triggerWin           = deps.triggerWin;
}

/**
 * Check all score thresholds and activate phases as needed.
 * Safe to call on every score change — each activate function
 * is idempotent (returns immediately if already active).
 */
export function checkPhaseTransitions() {
  if (state.score >= 500  && !state.bombMode)    activateBombMode();
  if (state.score >= 1500 && !state.frozenMode)  activateFrozenMode();
  if (state.score >= 3500 && !state.phase3Active) activatePhase3();
  if (state.score >= 6000 && !state.phase4Active && !state.phase5Active) activatePhase4();
  if (state.score >= 7500 && !state.phase5Active) activatePhase5();
  if (state.phase5Active) updateEscapeProgress();
  if (state.score >= 12000 && !state.eyeBossTriggered && !state.eyeBossActive) activateEyeBoss();
  if (state.score >= 15000 && !state.escaped && state.gameMode === 'normal') triggerWin();
}
